import React from "react";

export default function BrowseSectors({ industries, onOpen }) {
  const sorted = [...industries].sort((a, b) => a.name.localeCompare(b.name));

  return (
    <aside className="card browse-card">
      <h2 className="browse-title">Browse sectors</h2>
      <div className="sector-pills">
        {sorted.map((i) => (
          <button key={i.id} className="sector-pill" onClick={() => onOpen(i)}>
            {i.name}
          </button>
        ))}
      </div>
    </aside>
  );
}